import Box from "@mui/material/Box";
import TextFieldMUI from "@mui/material/TextField";
import TextField from "../../../../components/Form/TextField";
import { textFieldInputSx } from "../../../../styles";
import { BRAND_EDIT_MULTILINE_ROWS } from "../utils/constants";

const ROW_HEIGHT_PX = 23;
const FIELD_CHROME_PX = 16;
const LABEL_CHROME_PX = 18;

const inputRootSx = {
  ...textFieldInputSx["& .MuiInputBase-root"],
  flex: 1,
  minHeight: 0,
  alignItems: "stretch",
  backgroundColor: "transparent",
  border: "none",
  boxShadow: "none",
  "&:hover, &.Mui-focused, &.Mui-disabled": {
    backgroundColor: "transparent",
  },
  "&:before, &:after": {
    display: "none",
  },
};

const inputSx = {
  flex: 1,
  minHeight: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  "& .MuiInputBase-root": inputRootSx,
  "& .MuiOutlinedInput-notchedOutline": {
    display: "none",
  },
  "& .MuiInputBase-inputMultiline": {
    height: "100% !important",
    minHeight: "0 !important",
    resize: "none",
    overflowY: "auto !important",
    boxSizing: "border-box",
  },
};

export const BrandMultilineField = ({
  minRows = BRAND_EDIT_MULTILINE_ROWS,
  label = "",
  disabled = false,
  sx,
  control,
  ...fieldProps
}) => {
  const minHeight =
    minRows * ROW_HEIGHT_PX + FIELD_CHROME_PX + (label ? LABEL_CHROME_PX : 0);
  const Input = control ? TextField : TextFieldMUI;

  return (
    <Box
      sx={{
        ...textFieldInputSx["& .MuiInputBase-root"],
        display: "flex",
        width: "100%",
        overflow: "hidden",
        pr: "6px",
        pb: "6px",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          resize: disabled ? "none" : "vertical",
          overflow: "hidden",
          width: "100%",
          minHeight,
          height: minHeight,
        }}
      >
        <Input
          {...(control ? { control } : {})}
          label={label}
          disabled={disabled}
          variant="filled"
          hiddenLabel={!label}
          fullWidth
          multiline
          minRows={1}
          {...fieldProps}
          sx={inputSx}
        />
      </Box>
    </Box>
  );
};

export default BrandMultilineField;
